import React, { useEffect, useRef, useState } from "react";
import Input from "../../components/FormComponents/Input";
import Button from "../../components/FormComponents/Button";

const FormBuilderDeletePopup = (props) => {
  const modalRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [isMatch, setIsMatch] = useState(true);

  const confirmDelete = (response) => {
    document.dispatchEvent(new CustomEvent("userDeleteResponse", { detail: response }));
  };

  const handleInputValue = (e) => {
    const input = e.target.value.toLowerCase();
    const message = props.message.toLowerCase();
    setInputValue(e.target.value);
    setIsMatch(input === message);
  };

  const formatMessage = (message) => {
    return message.replace(/\s/g, "&nbsp;");
  };

  useEffect(() => {
    if (props.info === "app") setIsMatch(false);
    else setIsMatch(true);
    setInputValue("");

    requestAnimationFrame(() => {
      if (modalRef.current) {
        modalRef.current.classList.add("modal-open");
      }
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return (
    <div className="builder-modal__backdrop" onClick={() => confirmDelete("cancel")} onMouseDown={stopPropagation}>
      <div className="builder-modal__wrapper" onClick={stopPropagation} onMouseDown={stopPropagation}>
        <div
          ref={modalRef}
          className="builder-modal__container confirmation_popup_box"
          onClick={stopPropagation}
          onMouseDown={stopPropagation}
        >
          <div className="builder-modal__body flex_column align_center builder_form confirmation_popup">
            <div className="formBuilderPopup_inner_bodyBox_title">
              Are you sure you want to {props.action}&nbsp;
              <strong
                dangerouslySetInnerHTML={{
                  __html: formatMessage(props.message)
                }}
              />
              ?
            </div>

            {props.info === "app" && (
              <div className="builder_form">
                <label style={{ userSelect: "text" }}>
                  <strong
                    dangerouslySetInnerHTML={{
                      __html: `Type "${formatMessage(props.message)}" to confirm your action`
                    }}
                  />
                </label>
                <Input type="text" value={inputValue} onChange={handleInputValue} />
              </div>
            )}

            <div className="formBuilderPopup_bodyBox_button_div d_flex gap_2 w_auto">
              <Button
                variant="plain"
                className="confirmation_popup_buttons"
                onMouseDown={stopPropagation}
                onClick={(e) => {
                  stopPropagation(e);
                  confirmDelete("cancel");
                }}
              >
                Cancel
              </Button>

              <Button
                variant="delete"
                className="confirmation_popup_buttons text_transform_capitalize"
                disabled={!isMatch}
                onMouseDown={stopPropagation}
                onClick={(e) => {
                  stopPropagation(e);
                  confirmDelete("delete");
                }}
              >
                {props.action}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormBuilderDeletePopup;
